import { render, staticRenderFns } from "./giftGoodsList.vue?vue&type=template&id=7ddf0b62&scoped=true"
import script from "./giftGoodsList.vue?vue&type=script&lang=js"
export * from "./giftGoodsList.vue?vue&type=script&lang=js"
import style0 from "./giftGoodsList.vue?vue&type=style&index=0&id=7ddf0b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf0b62",
  null
  
)

export default component.exports